import gql from 'graphql-tag';

export default fields => gql`
mutation ($input: CreateAdvertiserInput!) {
    createAdvertiser (input: $input) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Advertisers/NewMutation.js